import React from "react";

const GoogleTranslateInitializer = () => {
    return (
        <div
            id="google_translate_element"
            style={{ display: 'none' }} // Hidden globally
        />
    );
};

export default GoogleTranslateInitializer;
